import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { FOUNDER, IMAGES } from "@/lib/content";

export default function Founder() {
  return (
    <section
      id="founder"
      className="relative bg-bg py-28 md:py-40 border-t border-white/10"
      data-testid="founder"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative overflow-hidden aspect-[3/4]">
                <motion.img
                  src={IMAGES.founder}
                  alt="Faye Joy — Founder"
                  className="h-full w-full object-cover img-cinematic"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                />
                <div className="absolute inset-0 border border-white/10 pointer-events-none" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <Overline>About {FOUNDER.name} · {FOUNDER.role}</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
                {FOUNDER.name}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 font-serif italic text-xl md:text-2xl text-ink/85 max-w-2xl leading-snug">
                {FOUNDER.summary}
              </p>
            </Reveal>

            <div className="mt-10 space-y-5 max-w-2xl font-sans text-base text-ink/65 leading-relaxed">
              {FOUNDER.bio.map((p, i) => (
                <Reveal key={i} delay={0.05 * i}>
                  <p>{p}</p>
                </Reveal>
              ))}
            </div>

            {FOUNDER.media.length > 0 && (
              <div className="mt-12">
                <Reveal>
                  <span className="font-sans text-[0.65rem] tracking-[0.3em] uppercase text-gold">
                    Press &amp; Media
                  </span>
                </Reveal>
                <div className="mt-4 space-y-3">
                  {FOUNDER.media.map((m) => (
                    <Reveal key={m.url}>
                      <a
                        href={m.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`founder-media-${m.publication.toLowerCase().replace(/\s+/g, "-")}`}
                        className="group inline-flex items-start gap-3 text-left"
                      >
                        <ArrowUpRight className="h-4 w-4 text-gold mt-1.5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                        <span>
                          <span className="block font-serif text-lg text-ink group-hover:text-gold transition-colors">
                            {m.label}
                          </span>
                          <span className="font-sans text-xs text-ash tracking-wide">
                            {m.publication}
                          </span>
                        </span>
                      </a>
                    </Reveal>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
